import { render, staticRenderFns } from "./FooteSection.vue?vue&type=template&id=4497c7b6&"
import script from "./FooteSection.vue?vue&type=script&lang=js&"
export * from "./FooteSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports